import { For, Portal } from "solid-js/web";
import type { Events } from "./_model";
import { $modals } from "./store";
import { Match, Show, Switch, createComponent, createMemo, runWithOwner, splitProps } from "solid-js";
import { solidstate } from ":setup/qstate";
import { directives$ } from ":ui/directives";

// TODO: add drawer to display other modals and allow jumping between them on click
// and allow linking dependant modals with modal tree like structure. also the for loop
// is going to be for the drawer and only one modal at a time is gonna be active
export default function Modal() {
  // @ts-ignore: unused function 'clickOutside'
  const { clickOutside } = directives$.events;
  // const { owner, ownerMeta } = solidstate.helpers.getOwner();

  return (
    <Portal>
      <Show when={$modals.value.length > 0}>
        <main class={`!fixed top-0 !z-5 flex flex-row items-center justify-center w-full h-full bg-bg-shade`}>
          <For each={$modals.value}>
            {(props, index) => {
              const [local, others] = splitProps(props, ["title", "element", "startExpanded"]);

              const $force_refresh = solidstate.create(0);
              const $expand = solidstate.create(local.startExpanded ?? false);
              function close() {
                $modals.set((s) => s.filter((_, i) => i !== index()));
              }
              function enlarge(props: { expand: boolean }) {
                $expand.set(props.expand);
              }
              function forceRefresh() {
                $force_refresh.set((s) => (s += 1));
              }
              const $element = createMemo(() => {
                const force_refresh = $force_refresh.value;
                if (force_refresh > 0) {
                  console.log("forced refresh");
                }
                return typeof local.element === "function"
                  ? local.element({ actions: { close, enlarge, forceRefresh } })
                  : local.element;
              });
              return (
                <section
                  {...others.outerContainer}
                  class={
                    "flex flex-col  self-center !items-center !justify-center !my-1 px-2 py-3 !z-10" +
                    " " +
                    "transition-all duration-300 ease-in-out" +
                    " " +
                    ($expand.value ? "w-full h-full" : " w-70% h-70% <md:(!w-85% !h-80%)") +
                    " " +
                    (others.outerContainer?.class ?? "")
                  }
                  // use:clickOutside={() => {
                  //   onModalAction("close", index());
                  // }}
                >
                  {/* inner container */}
                  <section
                    {...others.innerContainer}
                    class={
                      "!z-50 flex flex-col w-full h-full justify-between !self-center overflow-hidden rounded-lg" +
                      " " +
                      "bg-bg text-text px-2 py-1" +
                      " " +
                      (others.innerContainer?.class ?? "")
                    }
                  >
                    <div class="!sticky !top-0 flex flex-row justify-between items-center border-b border-solid  <md:(!flex-col-reverse mb-1)">
                      <h1 class="text-1.2rem <md:(text-1.05rem py-1)">{local.title || "TITLE"}</h1>
                      <div class="flex flex-row items-center space-x-2 <md:(w-full items-center justify-between py-2)">
                        <Switch>
                          <Match when={$expand.value}>
                            <i
                              class="icon-lucide:shrink w-30px h-30px cursor-pointer"
                              onclick={() => enlarge({ expand: false })}
                            />
                          </Match>
                          <Match when={!$expand.value}>
                            <i
                              class="icon-bx:expand w-30px h-30px cursor-pointer"
                              onclick={() => enlarge({ expand: true })}
                            />
                          </Match>
                        </Switch>
                        <i class="icon-carbon:close-filled w-30px h-30px cursor-pointer" onclick={() => close()} />
                      </div>
                    </div>
                    <div class="flex flex-col w-full h-full overflow-auto">
                      <Show keyed when={$element()}>
                        {$element()}
                      </Show>
                    </div>
                  </section>
                </section>
              );
            }}
          </For>
        </main>
      </Show>
    </Portal>
  );
}
